import { render, staticRenderFns } from "./addRecedeGoods.vue?vue&type=template&id=16083dfc&scoped=true&"
import script from "./addRecedeGoods.vue?vue&type=script&lang=js&"
export * from "./addRecedeGoods.vue?vue&type=script&lang=js&"
import style0 from "./addRecedeGoods.vue?vue&type=style&index=0&id=16083dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16083dfc",
  null
  
)

export default component.exports